module.exports = __webpack_public_path__ + "img/green-background.8ff3a9d8.png";